// Libraries
import React from 'react';

// Components
import { CardBlock, CardText } from 'Components/flowChart/components/NodePreview/components/styled';

// Types
import { INodePreviewProps } from 'Components/flowChart/components/NodePreview/types';

// Constants
import { DAYS_OF_WEEK_LABEL } from 'Components/flowChart/components/NodePreview/components/NodeDelay/constants';
import { IMetadata } from 'Components/flowChart/components/NodePreview/components/NodeDelay/types';

// Utils
import { getTriggerTime } from 'Components/flowChart/components/NodePreview/components/NodeDelay/utils';
import { deltaToContent } from 'Components/flowChart/utils';

const PATH = 'components/components/flowChart/components/Card/components/NodeDelay/index.tsx';

export interface INodeDelay extends INodePreviewProps<IMetadata> {}

const NodeDelay: React.FC<INodeDelay> = (props) => {
	try {
		const {
			node: { metadata },
			timezone,
		} = props;
		const { data, delayType } = metadata;

		if (delayType === 'amount_of_time') {
			const deltaContent = deltaToContent(data?.delta!);

			if (deltaContent) {
				return (
					<>
						<CardBlock>
							<CardText>Delay for the amount of time</CardText>
						</CardBlock>
						<CardBlock>
							<CardText>{`Delay for: ${deltaContent}`}</CardText>
						</CardBlock>
					</>
				);
			}
		}

		if (delayType === 'date_or_time') {
			const { timeUnit } = data;

			if (timeUnit === 'DATE') {
				const triggerTime = getTriggerTime(data.timeOfDay!, timezone, data.date);

				return (
					<>
						<CardBlock>
							<CardText>Delay until a date or time</CardText>
						</CardBlock>
						<CardBlock>
							<CardText>At a specific time</CardText>
							<CardText icon="icon-antsomi-event">{triggerTime}</CardText>
						</CardBlock>
					</>
				);
			}

			if (timeUnit === 'DAYS_OF_WEEK' || timeUnit === 'DAYS_OF_WEEK_CUSTOM') {
				const triggerTime = getTriggerTime(data.timeOfDay!, timezone);
				const daysOfWeek = data?.daysOfWeek?.map(({ day }) => DAYS_OF_WEEK_LABEL[day]).join(', ');

				return (
					<>
						<CardBlock>
							<CardText>Delay until a date or time</CardText>
						</CardBlock>
						<CardBlock>
							<CardText>{`Trigger time: ${triggerTime}`}</CardText>
						</CardBlock>
						<CardBlock>
							<CardText>Trigger on days of the week</CardText>
							<CardText>{daysOfWeek}</CardText>
						</CardBlock>
					</>
				);
			}

			if (timeUnit === 'SAME_DAY') {
				const triggerTime = getTriggerTime(data.timeOfDay!, timezone);

				return (
					<>
						<CardBlock>
							<CardText>Delay until a date or time</CardText>
						</CardBlock>
						<CardBlock>
							<CardText>Same day audience enters the node</CardText>
							<CardText icon="icon-antsomi-schedule">{triggerTime}</CardText>
						</CardBlock>
					</>
				);
			}
		}

		return null;
	} catch (e) {
		props.onError?.(e, {
			component: PATH,
			action: 'render -> NodeDelay',
			args: { props },
		});

		return null;
	}
};

export default NodeDelay;
